import { useState } from 'react'

import {
    FilePostWrapper,
    LivePostWrapper,
    PollPostWrapper,
    PostGoalWrapper,
    StoryPostWrapper,
    TextPostWrapper
} from 'components-ref/molecules'
import { PremiumPost } from 'components-ref/organisms'

// import { apiViewPost, postsImpression } from 'services/endpoints/tracking'

import { type IProps } from './Post.types'

import './_post.scss'

export const Post = ({
    postIndex,
    role,
    postData,
    dataQuery,
    isMyPost,
    allFiles,
    purchasePostCb,
    purchaseProcessing,
    updateCounter,
    toggleStats,
    setVideoCurrentTime,
    setIsPlaying,
    isPlaying = false,
    preloadMedia = false,
    onOpenOptions,
    isInViewport = true,
    showPreviewVideo = false
    
}: IProps) => {

    const [paymentMethod, setPaymentMethod] = useState<{
        method: 'card' | 'wallet'
        cardId: string | undefined
    }>({
        method: 'wallet',
        cardId: undefined
    })

    if (postData.price && !postData.is_purchased) {
        return (
            <PremiumPost
                postData={postData}
                postIndex={postIndex}
                dataQuery={dataQuery}
                processing={purchaseProcessing}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                purchaseCb={() => {
                    purchasePostCb({
                        postId: postData.id,
                        paymentMethod: paymentMethod.method,
                        cardId: paymentMethod.cardId,
                    })
                }}
            />
        )
    }

    if (postData.poll) {
        return (
            <PollPostWrapper
                dataQuery={dataQuery}
                isMyPost={isMyPost}
                postData={postData}
                postIndex={postIndex}
            />
        )
    }
    if (postData.goal) {
        return (
            <PostGoalWrapper
                dataQuery={dataQuery}
                postData={postData}
                postIndex={postIndex}
                role={role}
            />
        )
    }

    if (postData.stories && !(postData.stories.length === 0)) {
        return (
            <StoryPostWrapper
                dataQuery={dataQuery}
                postData={postData}
                postIndex={postIndex}
                toggleStats={toggleStats}
            />
        )
    }

    if (postData.live_scheduled_at) {
        return (
            <LivePostWrapper
                dataQuery={dataQuery}
                postData={postData}
                postIndex={postIndex}
            />
        )
    }

    if (allFiles.length > 0) {
        return (
            <FilePostWrapper
                allFiles={allFiles}
                dataQuery={dataQuery}
                postData={postData}
                postIndex={postIndex}
                updateCounter={updateCounter}
                setVideoCurrentTime={setVideoCurrentTime}
                setIsPlaying={setIsPlaying}
                isPlaying={isPlaying}
                preloadMedia={preloadMedia}
                onOpenOptions={onOpenOptions}
                isInViewport={isInViewport}
                showPreviewVideo={showPreviewVideo}
            />
        )
    }

    return (
        <TextPostWrapper
            dataQuery={dataQuery}
            postData={postData}
            postIndex={postIndex}
        />
    )
}
